<template>
  <div>
    <form-component>
      <input-select 
        id="outcomeType"
        name="outcomeType"
        label="Outcome"
        :options="options"
        v-model="outcomeType" />
      <div style="display:flex;">
        <input-text-area 
          id="internalExplainer"
          name="internalExplainer"
          label="Internal Explainer (BetterMynd Admin Facing)"
          type="text"
          v-model="internalExplainer" />
        <input-text-area 
          id="publicExplainer"
          name="publicExplainer"
          label="Public Explainer (Campus Admin Facing)"
          type="text"
          v-model="publicExplainer" />
      </div>
    </form-component>
    <button class="btn btn-ghost" type="button" @click="saveChanges">
        Save Changes
    </button>
    <button class="btn btn-ghost" type="button" @click="cancelChanges">
        Cancel
    </button>
  </div>
</template>

<script>
import InputTextArea from '@/components/inputs/InputTextArea.vue'
import InputSelect from '@/components/inputs/InputSelect.vue'
import FormComponent from '@/components/FormComponent.vue'

export default {
  name: 'EditOutcome',
  components: {
    InputTextArea,
    InputSelect,
    FormComponent,
  },
  props: {
    outcome: {
      type: Object,
      require: true,
    }
  },
  data() {
    return {
      outcomeType: null,
      publicExplainer: null,
      internalExplainer: null,
      options: [
        { id: 'Successful', display_label: 'Successful' },
        { id: 'UserNoShow', display_label: 'No Show - Client' },
        { id: 'CounselorNoShow', display_label: 'No Show - Counselor' },
        { id: 'BothNoShow', display_label: 'No Show - Both' },
        { id: 'UserCanceled', display_label: 'Canceled - Client' },
        { id: 'UserLateCanceled', display_label: 'Canceled - Client (Late)' },
        { id: 'CounselorCanceled', display_label: 'Canceled - Counselor' },
        { id: 'AdminCanceled', display_label: 'Canceled - Admin' },
      ],
    }
  },
  mounted() {
    this.outcomeType = this.outcome.type;
    this.publicExplainer = this.outcome.publicExplainer;
    this.internalExplainer = this.outcome.internalExplainer;
  },
  computed:{
    changes() {
      const publicExplainerModified = this.publicExplainer && this.outcome.publicExplainer != this.publicExplainer;
      const internalExplainerModified = this.internalExplainer && this.outcome.internalExplainer != this.internalExplainer;
      const outcomeTypeModified = this.outcomeType && this.outcome.type != this.outcomeType;

      if(!outcomeTypeModified && !publicExplainerModified && !internalExplainerModified) 
        return null;

      return {
        type: outcomeTypeModified ? this.outcomeType : undefined,
        publicExplainer: publicExplainerModified ? this.publicExplainer : undefined,
        internalExplainer: internalExplainerModified ? this.internalExplainer : undefined,
      }
    },
  },
  methods: {
    async saveChanges() {
      if(!this.changes) {
        this.$emit('invalid', 'Please make a change before saving.')
        return;
      }
      if(this.changes.type && !this.changes.publicExplainer && !this.changes.internalExplainer) {
        this.$emit('invalid', 'Please provide an internal explanation as to why the outcome was modified.')
        return;
      }

      this.$emit('save', this.changes);
    },
    cancelChanges() {
      this.outcomeType = this.outcome.type;
      this.publicExplainer = this.outcome.publicExplainer;
      this.internalExplainer = this.outcome.internalExplainer;

      this.$emit('cancel', this.outcome);
    },
  },
}
</script>

<style>

</style>